const Main = () => import('../../pages/main')
export default {
	path: '/message',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'message',
			path: 'index',
			component: () => import('../../pages/Message'),
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '留言管理',
				icon: 'icon-nav icon-nav-message'
			}
		}
	]
}
